import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'webapp-compat-tasklist',
  template: `
  <div
    *ngIf="projectId"
    id="webapp-tasklist-container">
    <app-tasklist
      id="webapp-tasklist"
      class="WebappCompatTasklist-hide"
      [projectId]="projectId"
      [freelancerView]="freelancerView"
    >
    </app-tasklist>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['compat-tasklist.component.scss'],
})
export class CompatTasklistComponent implements OnInit {
  projectId: number;
  freelancerView = false;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    const w = <any>window;

    w.webappCompatTasklist = {
      show: (projectId: number, viewAsFreelancer: boolean) => {
        this.projectId = projectId;
        this.freelancerView = viewAsFreelancer;
        w.webappCompat.tasklist.tasklistLoaded = true;

        this.changeDetectorRef.detectChanges();
        return Promise.resolve();
      },
    };
  }
}
